import React from "react"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import SegueLink from "app/static/frontend/middleware/SegueLink"

const AddColumnButton = ({ columnIndex, sheetId }) => (
    <SegueLink to={`/sheet/${sheetId}/add_column/${columnIndex + 1}/`}>
        <Tooltip label={`Add a column directly to the right of this column.`}>
            <div>
                <Icon name="plus-circle" data-cy="cy-plus-circle-icon" />
            </div>
        </Tooltip>
    </SegueLink>
)

export default AddColumnButton
